import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import * as React from 'react';
import {
  IGeoObjectBalloonProps as IGeoObjectBalloonResponse,
  IInfrastructureItem,
  IInfrastructureProps,
  INFRASTRUCTURE_MAP_ICON,
  trackMapPinClick,
} from '../utils';
import { renderToStaticMarkup } from 'react-dom/server';
import { MapBalloon } from '../../../components/Infrastructure';
import { findGeoObjectDatum } from '../helpers';

interface IGeoObjectBalloonProps {
  infrastructureByYearRef: IInfrastructureProps['infrastructureByYearRef'];
  startBuildingRoute: (item?: IInfrastructureItem) => void;
}

export const useGeoObjectBalloon = ({
  infrastructureByYearRef,
  startBuildingRoute,
}: IGeoObjectBalloonProps): IGeoObjectBalloonResponse => {
  const infrastructurePointRef = React.useRef<IInfrastructureItem | null>(null);
  const handleBalloonRouteButtonClick = React.useCallback(
    (item: IInfrastructureItem) => {
      infrastructurePointRef.current = item;
      startBuildingRoute(item);
    },
    [startBuildingRoute],
  );

  const handleBalloonHtmlFirstFetch = React.useCallback(async (geoObject: IMapGeoObject): Promise<string> => {
    const {
      options: { id },
    } = geoObject;

    const datum = findGeoObjectDatum(id, infrastructureByYearRef.current);
    const item = datum?.infrastructureItem;

    if (!item) {
      return Promise.reject(new Error('Не верный тип пина!'));
    }

    const IconComponent = INFRASTRUCTURE_MAP_ICON[item.type];
    const markup = renderToStaticMarkup(
      <MapBalloon
        id={`route-button-${item.id}`}
        title={item.title}
        distance={item.distance}
        icon={<IconComponent color="icon-inverted-default" />}
      />,
    );

    return Promise.resolve(markup);
  }, []);

  const handleBalloonOpen = React.useCallback(
    (geoObject: IMapGeoObject) => {
      const datum = findGeoObjectDatum(geoObject.options.id, infrastructureByYearRef.current);
      const item = datum?.infrastructureItem as IInfrastructureItem;

      const routeButton = document.getElementById(`route-button-${item.id}`);

      if (routeButton) {
        routeButton.addEventListener('click', () => {
          handleBalloonRouteButtonClick(item);
        });
      }

      trackMapPinClick();
    },
    [handleBalloonRouteButtonClick],
  );

  return {
    onBalloonHtmlFirstFetch: handleBalloonHtmlFirstFetch,
    onBalloonOpen: handleBalloonOpen,
  };
};
